import React from 'react';
import { Shield, Lock } from 'lucide-react';
import { Button } from './ui';
export const Hero = () => {
  return <section className="pt-20 pb-10 px-4 md:pt-32 md:pb-24 bg-gradient-to-b from-white to-brand-cream overflow-hidden" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <div className="flex flex-col items-center text-center space-y-5 md:space-y-8" data-id="element-111">
          <div className="inline-block bg-brand-teal/10 text-brand-teal font-bold px-4 py-1.5 rounded-full text-sm tracking-wide uppercase mb-2" data-id="element-112">
            Guía para Madres — Basada en Evidencia Médica
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-charcoal leading-tight" data-id="element-113">
            Descubrí Cómo Terminar Con La{' '}
            <span className="text-brand-coral underline decoration-brand-coral/30 decoration-4 underline-offset-4" data-id="element-114">
              "Batalla del Baño"
            </span>{' '}
            Para Siempre
          </h1>

          <h2 className="text-xl md:text-2xl font-semibold text-brand-teal" data-id="element-115">
            — Sin laxantes. Sin dramas. Sin llanto. —
          </h2>

          <p className="text-lg md:text-xl text-gray-600 font-inter leading-relaxed max-w-2xl mx-auto" data-id="element-116">
            La guía que te explica, <em data-id="element-117">de mamá a mamá y sin jerga médica</em>,{' '}
            <strong data-id="element-118">por qué las fibras y los laxantes no funcionan</strong> y{' '}
            <span className="underline decoration-gray-300 decoration-2 underline-offset-2" data-id="element-119">
              qué hacer exactamente
            </span>{' '}
            para que tu hijo vaya al baño{' '}
            <strong data-id="element-120">sin dolor y con confianza</strong>.
          </p>

          <div className="w-full max-w-xs md:max-w-md mx-auto my-4 md:my-6" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/xsLJQdG3n8SXvqVPakBcEP/Diseno_sin_titulo_18_800x800.webp" alt="Guía Cómo Ayudar a Tu Hijo con la Constipación y sus bonos" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-122" />
          </div>

          <div className="pt-2 flex flex-col items-center space-y-4" data-id="element-123">
            <Button className="text-xl py-4 px-8 md:py-5 md:px-10 animate-bounce-subtle" data-id="element-124">
              ✅ Sí, Quiero La Solución Ahora →
            </Button>

            <div className="flex flex-col items-center space-y-2 text-sm text-gray-500 font-medium mt-2" data-id="element-125">
              <div className="flex items-center gap-2 text-brand-charcoal" data-id="element-126">
                <Lock className="w-4 h-4 text-brand-green" data-id="element-127" />
                <span data-id="element-128">— Garantía de 7 días sin preguntas</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-129">
                <span data-id="element-130">
                  Acceso digital inmediato · Pago único · Sin cuotas ocultas
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};